import Edit4Fill from '@/assets/icons/edit_4_fill.svg?component';
import FishFill from '@/assets/icons/fish_fill.svg?component';
import Group3Fill from '@/assets/icons/group_3_fill.svg?component';
import Heartbeat2Fill from '@/assets/icons/heartbeat_2_fill.svg?component';
import QuestionFill from '@/assets/icons/question_fill.svg?component';
import Settings3Fill from '@/assets/icons/settings_3_fill.svg?component';
import Transfer4Fill from '@/assets/icons/transfer_4_fill.svg?component';
import TransferFill from '@/assets/icons/transfer_fill.svg?component';
import Winch from '@/assets/icons/winch.svg?component';

import { cageMonitoringItems } from './cageMonitoringItems';
import type { SidebarLevelConfig } from './types';

/** Cage level. */
export const cageLevel: SidebarLevelConfig = {
    level: 'cage',
    matchPattern: '/c/:clientId/location/:locationId/pen/:cageId',
    back: {
        title: 'sidebarItems.back.toLocation',
        urlTemplate: '/c/:clientId/location/:locationId',
    },
    items: [
        ...cageMonitoringItems,
        {
            id: 'cage-health',
            label: 'healthModule.routes.health',
            analyticsLabel: 'Health',
            path: '/health',
            icon: Heartbeat2Fill,
            exact: true,
            visibility: {
                requiresLicenses: ['FISH_HEALTH.MIN'],
                requiresNewBioscope: true,
            },
            children: [
                {
                    id: 'cage-health-wounds',
                    label: 'healthModule.routes.wounds',
                    analyticsLabel: 'Wounds',
                    path: '/health/body-wounds',
                    activePathPrefixes: ['/health/snout-wounds'],
                    exact: false,
                },
                {
                    id: 'cage-health-scale-loss',
                    label: 'healthModule.routes.scaleLoss',
                    analyticsLabel: 'Scale loss',
                    path: '/health/scale-loss',
                    exact: true,
                },
                {
                    id: 'cage-health-skin-bleeding',
                    label: 'healthModule.routes.skinBleeding',
                    analyticsLabel: 'Skin bleeding',
                    path: '/health/skin-bleeding',
                    exact: true,
                },
                {
                    id: 'cage-health-fin-status',
                    label: 'healthModule.routes.finStatus',
                    analyticsLabel: 'Fin status',
                    path: '/health/fin-status',
                    exact: true,
                },
                {
                    id: 'cage-health-emaciation',
                    label: 'healthModule.routes.emaciation',
                    analyticsLabel: 'Emaciation',
                    path: '/health/emaciation',
                    exact: true,
                },
                {
                    id: 'cage-health-deformities',
                    label: 'healthModule.routes.deformities',
                    analyticsLabel: 'Deformities',
                    path: '/health/deformities',
                    exact: false,
                },
                {
                    id: 'cage-health-cataract',
                    label: 'healthModule.routes.cataract',
                    analyticsLabel: 'Cataract',
                    path: '/health/cataract',
                    exact: true,
                },
                {
                    id: 'cage-health-eye-damage',
                    label: 'healthModule.routes.eyeDamage',
                    analyticsLabel: 'Eye damage',
                    path: '/health/eye-damage',
                    exact: true,
                },
                {
                    id: 'cage-health-maturation',
                    label: 'healthModule.routes.maturation',
                    analyticsLabel: 'Maturation',
                    path: '/health/maturation',
                    exact: true,
                },
            ],
        },
        {
            id: 'cage-behavior',
            label: 'behaviorModule.routes.dashboard',
            analyticsLabel: 'Behavior',
            path: '/behavior',
            icon: FishFill,
            exact: true,
            visibility: [{ requiresOptoScaleAdmin: true }, { requiresLicenses: ['BEHAVIOR'] }],
            children: [
                {
                    id: 'cage-behavior-swim-speed',
                    label: 'behaviorModule.routes.swimSpeed',
                    analyticsLabel: 'Swim speed',
                    path: '/behavior/swim-speed',
                    exact: true,
                },
                {
                    id: 'cage-behavior-respiration',
                    label: 'behaviorModule.routes.respiration',
                    analyticsLabel: 'Respiration',
                    path: '/behavior/respiration',
                    exact: true,
                },
                {
                    id: 'cage-behavior-tilt',
                    label: 'behaviorModule.routes.tilt',
                    analyticsLabel: 'Tilt',
                    path: '/behavior/tilt',
                    exact: true,
                },
            ],
        },
        {
            id: 'cage-winch',
            label: 'sidebarItems.cageLevel.moveBioscope',
            analyticsLabel: 'Move bioscope',
            path: '/move-bioscope',
            icon: Winch,
            exact: true,
            visibility: { requiresWinch: true, requiresBioscopeV2: true },
        },
        {
            id: 'cage-reports',
            label: 'sidebarItems.cageLevel.reports',
            analyticsLabel: 'Reporting',
            path: '/reports',
            icon: Edit4Fill,
        },
        {
            id: 'cage-compare',
            label: 'sidebarItems.shared.compare',
            analyticsLabel: 'Compare',
            path: '/compare',
            icon: TransferFill,
            exact: true,
        },
        {
            id: 'cage-settings',
            label: 'sidebarItems.cageLevel.settings',
            analyticsLabel: 'Settings',
            path: '/settings',
            icon: Settings3Fill,
        },
        // Static items (below divider)
        {
            id: 'cage-change-pen',
            label: 'sidebarItems.shared.changePen',
            analyticsLabel: 'Change pen',
            path: '/change-pen',
            icon: Transfer4Fill,
            exact: true,
            isStatic: true,
            visibility: [{ requiresClientAdmin: true }, { requiresCurrentLocationAdmin: true }],
        },
        {
            id: 'cage-users',
            label: 'sidebarItems.shared.users',
            analyticsLabel: 'Users',
            path: '/users',
            icon: Group3Fill,
            exact: true,
            isStatic: true,
            visibility: { requiresClientAdmin: true },
        },
        {
            id: 'cage-help',
            label: 'sidebarItems.shared.help',
            analyticsLabel: 'Help',
            path: '/help',
            icon: QuestionFill,
            exact: true,
            isStatic: true,
        },
    ],
};
